import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { handleFormInput } from "../../../utills/formutilities";
import Loginbtn from "../../components/common/loginbtn";
import { useLocation, useNavigate } from "react-router-dom";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import {
  alphaletter,
  emailRegex,
  NumberRegex,
} from "../../../utills/form-regex";
// import PhoneInput from "react-phone-input-2";
import {
  addEmployee,
  getAllCompanies,
  getAllDepartment,
  getAllHirarchy,
} from "../../../services/api-services";
import { ROUTES } from "../../routes/url-constant";

const AddComapnyEmployee = () => {
  const location = useLocation();
  const navigate = useNavigate();

  let Employeetype = location?.state?.pageType;
  let editEmployeeData = location?.state?.Data;

  const [Employeebtndisable, setEmployeebtndisable] = useState(false);
  const [formError, setFormError] = useState({});
  const [EmployeebtnLoader, setEmployeebtnLoader] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [hierarchyOptions, setHierarchyOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [employeeData, setEmployeeData] = useState({
    id: editEmployeeData?.id || "",
    employeeName: editEmployeeData?.employeeName || "",
    email: editEmployeeData?.email || "",
    mobileNumber: editEmployeeData?.mobileNumber || "",
    department: editEmployeeData?.department || "",
    hierarchy: editEmployeeData?.hierarchy || "",
    departmentType: editEmployeeData?.departmentType || "",
    hierarchyType: editEmployeeData?.hierarchyType || "",
    companyId: editEmployeeData?.companyId || "",
    modelId: editEmployeeData?.modelId || "",
    modelName: editEmployeeData?.modelName || "",
    image: editEmployeeData?.image || "",
  });

  // API Calls
  const getallCompany = async (status) => {
    try {
      const response = await getAllCompanies(status);
      if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody?.map((data) => ({
          value:  String(data?.id),
          label: data?.companyName,
          modelName: data?.modelResponse?.modelName,
          modelId: data?.modelId,
        }));
        setCompanyList(companyOptions);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getAllDepartmentData = async (companyId) => {
    try {
      const response = await getAllDepartment(companyId);
      if (response?.data?.responseCode === 200) {
        const departments = response?.data?.data || [];
        const options = departments.map((dept) => ({
          id: dept?.id,
          value: dept?.departmentName,
          label: dept?.departmentName,
        }));
        setDepartmentOptions(options);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getAllHierarchyData = async (companyId) => {
    try {
      const response = await getAllHirarchy(companyId);
      if (response?.data?.responseCode === 200) {
        const hierarchies = response?.data?.data || [];
        const options = hierarchies.map((item) => ({
          id: item?.id,
          value: item?.hierarchyName,
          label: item?.hierarchyName,
        }));
        setHierarchyOptions(options);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };
  useEffect(() => {
    getallCompany(1);
  }, []);
  useEffect(() => {
    if (employeeData.companyId) {
      getAllDepartmentData(employeeData.companyId);
      getAllHierarchyData(employeeData.companyId);
    }
  }, [employeeData.companyId]);
// Auto-map department & hierarchy name to ID when editing
useEffect(() => {
  if (Employeetype === "Edit") {
    // Map Department
    if (departmentOptions.length > 0 && editEmployeeData?.department) {
      const matchedDept = departmentOptions.find(
        (d) => d.value === editEmployeeData.department
      );
      if (matchedDept) {
        setEmployeeData((prev) => ({
          ...prev,
          departmentId: matchedDept.id,
          department: matchedDept.value,
        }));
      }
    }

    // Map Hierarchy
    if (hierarchyOptions.length > 0 && editEmployeeData?.hierarchy) {
      const matchedHierarchy = hierarchyOptions.find(
        (h) => h.value === editEmployeeData.hierarchy
      );
      if (matchedHierarchy) {
        setEmployeeData((prev) => ({
          ...prev,
          hierarchyId: matchedHierarchy.id,
          hierarchy: matchedHierarchy.value,
        }));
      }
    }
  }
}, [departmentOptions, hierarchyOptions]);

  // Handle dropdown changes
 const handleSelect = (event) => {
  const { name, value } = event.target;

  if (name === "department") {
    const selectedDept = departmentOptions.find((d) => d.value === value);

    setEmployeeData((prev) => ({
      ...prev,
      department: value === "Other" ? "" : value,
      departmentId: selectedDept?.id || "",
      departmentType: value === "Other" ? "Other" : "",
    }));
  } else if (name === "hierarchy") {
    const selectedHierarchy = hierarchyOptions.find((h) => h.value === value);

    setEmployeeData((prev) => ({
      ...prev,
      hierarchy: value === "Other" ? "" : value,
      hierarchyId: selectedHierarchy?.id || "",
      hierarchyType: value === "Other" ? "Other" : "",
    }));
  } else if (name === "companyId") {
    const selectedCompany = companyList.find((c) => c.value === value);

    setEmployeeData((prev) => ({
      ...prev,
      companyId: value,
      modelId: selectedCompany?.modelId || "",
      modelName: selectedCompany?.modelName || "",
    }));
  }
};


  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Email,
        emailRegex,
        formError,
        setFormError
      );
    }

    if (name === "departmentType") {
      setEmployeeData({
        ...employeeData,
        department: value,
        departmentType: "Other",
      });
    } else if (name === "hierarchyType") {
      setEmployeeData({
        ...employeeData,
        hierarchy: value,
        hierarchyType: "Other",
      });
    } else {
      setEmployeeData(handleFormInput(e, employeeData));
    }
  };

  const validateEmployeeData = () => {
    const errors = {};

    if (!employeeData.employeeName) errors.employeeName = "Employee Name is required";
    if (!employeeData.email) errors.email = "Email is required";
    else if (!emailRegex.test(employeeData.email)) errors.email = "Invalid email";

    if (!employeeData.companyId) errors.companyId = "Company is required";

    if (!employeeData.department && employeeData.departmentType !== "Other")
      errors.department = "Department is required";

    if (!employeeData.hierarchy && employeeData.hierarchyType !== "Other")
      errors.hierarchy = "Hierarchy is required";

    setFormError(errors);

    return Object.keys(errors).length === 0;
  };


  const handleAddEmployee = async () => {
    if (!validateEmployeeData()) {
      toastEmitter("error", "Please fill all required fields correctly");
      return;
    }
    const payload = {
      id: employeeData.id,
      employeeName: employeeData.employeeName,
      mobileNumber: employeeData.mobileNumber,
      email: employeeData.email,
      department:
        employeeData.departmentType === "Other"
          ? employeeData.department
          : employeeData.departmentId, // use ID if selected from list
      hierarchy:
        employeeData.hierarchyType === "Other"
          ? employeeData.hierarchy
          : employeeData.hierarchyId,
      image: employeeData.image,
      departmentType: employeeData.departmentType,
      hierarchyType: employeeData.hierarchyType,
      companyId: employeeData.companyId,
    };

    setEmployeebtnLoader(true);
    setEmployeebtndisable(true);

    try {
      const response = await addEmployee(payload);
      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.COMPANYEMPLOYEEMANAGEMENT);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setEmployeebtnLoader(false);
      setEmployeebtndisable(false);
    }
  };

  return (
    <>
      <TableHeading
        className="cursor-pointer"
        firstData="Customer Management"
        icon={RIGHTARROW_ICON}
        secondData="Employee Management"
        iconshow={true}
        thirdData={
          Employeetype === "Edit"
            ? "Update Employee"
            : Employeetype === "view"
              ? "View Employee"
              : "Add Employee"
        }
        onFirstDataClick={() => navigate(ROUTES.COMPANYEMPLOYEEMANAGEMENT)}
      />

      <div className="container-fluid ">
        <div className="caspera_employee_add">
          <div className="row">
            {/* Employee Name */}
            <div className="col-md-12">
              <Inputwithlable
                disable={Employeetype === "view"}
                placeHolder="Enter Employee Name"
                lableclassName="addInput-label"
                name="employeeName"
                type="text"
                showastrict={true}
                labelName="Enter Name"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={employeeData.employeeName}
              />
            </div>

            {/* Company */}
            <div className="col-md-6">
              <DropDownWithLabel
                disabled={Employeetype === "view"}
                labelName="Select Company"
                name="companyId"
                lableclassName="addInput-label"
                options={companyList}
                showastrict={true}
                className="form-control addInputText-lable"
                handleSelect={handleSelect}
                value={employeeData.companyId}
              />
            </div>

            {/* Email */}
            <div className="col-md-6">
              <Inputwithlable
                disable={Employeetype === "view"}
                placeHolder="Enter Email"
                name="email"
                lableclassName="addInput-label"
                showastrict={true}
                type="text"
                className="form-control addInputText-lable"
                labelName="Enter Email"
                handleChange={handleChange}
                value={employeeData?.email}
              />
              <ErrorMsg error={formError?.email} />
            </div>

            {/* Mobile Number */}
            {/* <div className="col-md-6 phoneinputdiv">
              <label htmlFor="inputState" className="form-label input-lable">
                Enter Mobile Number
              </label>
              <PhoneInput
                country={isNumber}
                enableAreaCodes={true}
                value={employeeData.mobileNumber}
                onChange={handleNumber}
                className="addInputText-lable"
                disabled={Employeetype === "view"}
              />
            </div> */}

            {/* Department Dropdown */}
            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Department"
                name="department"
                showastrict={true}
                lableclassName="addInput-label"
                options={departmentOptions}
                handleSelect={handleSelect}
                value={
                  employeeData.departmentType === "Other"
                    ? "Other"
                    : employeeData.department
                }
                className="form-control addInputText-lable"
                disabled={Employeetype === "view"}
              />
              {/* Show input if "Other" selected */}
              {employeeData.departmentType === "Other" && (
                <Inputwithlable
                  disable={Employeetype === "view"}
                  placeHolder="Enter custom department"
                  name="departmentType"
                  lableclassName="addInput-label"
                  type="text"
                  showastrict={true}
                  labelName="Other Department"
                  handleChange={handleChange}
                  className="form-control addInputText-lable"
                  value={employeeData.department}
                />
              )}
            </div>

            {/* Hierarchy Dropdown */}
            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Hierarchy"
                name="hierarchy"
                showastrict={true}
                lableclassName="addInput-label"
                options={hierarchyOptions}
                handleSelect={handleSelect}
                className="form-control addInputText-lable"
                value={
                  employeeData.hierarchyType === "Other"
                    ? "Other"
                    : employeeData.hierarchy
                }
                disabled={Employeetype === "view"}
              />
              {/* Show input if "Other" selected */}
              {employeeData.hierarchyType === "Other" && (
                <Inputwithlable
                  disable={Employeetype === "view"}
                  placeHolder="Enter custom hierarchy"
                  name="hierarchyType"
                  lableclassName="addInput-label"
                  type="text"
                  showastrict={true}
                  labelName="Other Hierarchy"
                  className="form-control addInputText-lable"
                  handleChange={handleChange}
                  value={employeeData.hierarchy}
                />
              )}
            </div>
          </div>

          {/* Submit Button */}
          {Employeetype !== "view" && (
            <div className="pt-4 d-flex justify-content-center">
              <Loginbtn
                className="submitbtn px-5"
                handleClick={handleAddEmployee}
                type="button"
                btnName={Employeetype === "Edit" ? "Update" : "ADD"}
                disablebtn={Employeebtndisable}
                loader={EmployeebtnLoader}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddComapnyEmployee;
